import { useMemo } from "react";

import { Box, Container, Grid, Typography } from "@mui/material";
import i18next from "i18next";

import { MainLayout } from "@shared/ui/MainLayout";
import MDBox from "@vendor/components/MDBox";
import { getUrlFile } from "@shared/utils/setting";

import { Cover } from "../components/Cover";
import { usePeopleCulture } from "../hooks/usePeopleCulture";

const COVER_FILE = "06_Cover_Form.png";

export const FormationPage = () => {
  const { data, isFetching } = usePeopleCulture();

  const imageServer = useMemo(() => {
    if (!data) return null;
    const cover = (data.imageCover ?? []).find((image) => image.fileName === COVER_FILE);
    return cover ? [cover] : null;
  }, [data]);

  // Mismo caso que LinkUtils: el contrato declara `links` como objeto libre.
  const links: Record<string, string | undefined> = (data?.links ?? {}) as Record<string, string | undefined>;

  const getFile = (fileName: string) => {
    const value = imageServer?.find((image) => image.fileName === fileName);
    if (!value) return "";
    return getUrlFile(value.fileId as string, value.extension as string);
  };

  return (
    <MainLayout loading={isFetching}>
      <Container>
        {imageServer && <Cover getFile={getFile} fileName={COVER_FILE} name="Formación" />}
        <MDBox py={3}>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("imputationOfHours")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("imputationOfHoursMessage")}
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Horas_Portal"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("requesGeneration")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("requesGenerationMessage")}
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Solicitides"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("vacancies")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("vacancyMessage")}
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Vacantes"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("billing")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("billingMessage")}
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Facturas_Portal"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("imputationOfHoursInRedmine")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("imputationOfHoursInRedmineMessage")}{" "}
                  <a href={`${links["Link_Instructivo_Redmine"]}`} target="_blank" rel="noreferrer">
                    click aquí
                  </a>
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Horas_Redmine"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
          <Grid size={12}>
            <Container>
              <Box sx={{ padding: "50px" }}>
                <Typography variant="h4" align="center">
                  {i18next.t("billing")}
                </Typography>
                <Typography variant={"p" as "body1"} align="justify">
                  {i18next.t("billingMessageProvider")}{" "}
                  <a href={`${links["Link_Instructivo_Facturacion"]}`} target="_blank" rel="noreferrer">
                    click aquí
                  </a>
                </Typography>
                <iframe
                  width="100%"
                  height="400px"
                  src={`${links["Link_Video_Facturas"]}`}
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </Box>
            </Container>
          </Grid>
        </MDBox>
      </Container>
    </MainLayout>
  );
};
